<template>
  <div class="orderSuccess">
    <span class="time">下单时间：2019-08-12</span>
    <img src="../assets/car/paySuccess.png" class="success" alt />
    <div class="goodsBox">
      <div class="item" v-for="item in goods" :key="item.id">
        <img class="goodsImg" :src="item.img" alt />
        <div class="infor">
          <h6>{{ item.title }}</h6>
          <span class="specs">{{ item.specs }}</span>
          <div class="price">
            <span class="newPrice">￥{{ item.newPrice }}</span>
            <span class="oldPrice">￥{{ item.oldPrice }}</span>
            <span class="num">x{{ item.num }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="bottomBox">
      <router-link tag="div" :to="{name:'orderList'}" class="seeOrder">查看订单</router-link>
      <div class="share">分享订单</div>
    </div>
   
  </div>
</template>

<style lang="less">
.orderSuccess {
  position: relative;
  .success {
    position: absolute;
    top: 40px;
    right: 40px;
    width: 175px;
    height: 175px;
  }
  .time {
    font-size: 24px;
    color: #666;
    width: 100%;
    height: 85px;
    display: block;
    line-height: 85px;
    padding-left: 24px;
    box-sizing: border-box;
    background: #fff;
    border-bottom: 1px solid #eee;
  }

  .goodsBox {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 24px;
    background-color: #fff;
    .item {
      margin: 30px 0;
      display: flex;
      align-items: center;
      .check img {
        width: 36px;
        height: 36px;
      }
      .goodsImg {
        width: 160px;
        height: 160px;
        overflow: hidden;
        border: 1px solid #eee;
      }
      .infor {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        h6 {
          font-size: 30px;
          font-weight: 500;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0;
        }
        .specs {
          font-size: 22px;
          color: #666;
          margin: 15px 0 60px;
        }
        .price {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .newPrice {
            font-size: 30px;
            color: #e42129;
          }
          .oldPrice {
            font-size: 22px;
            color: #999;
            text-decoration: line-through;
            margin-left: 12px;
          }
          .num {
            flex: 1;
            text-align: right;
            font-size: 24px;
            color: #333;
          }
        }
      }
    }
  }
  .bottomBox {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 90px;
    background-color: #fff;
    div {
      width: 241px;
      height: 72px;
      box-sizing: border-box;
      border: 1px solid;
      font-size: 30px;
      line-height: 72px;
      text-align: center;
      border-radius: 10px;
    }
    .seeOrder {
      color: #666;
      border-color: #666;
    }
    .share {
      color: #e42129;
      border-color: #e42129;
      margin-left: 68px;
    }
  }
  .pwd {
    width: 100%;
    height: 600px;
    padding-top: 30px;
    position: fixed;
    background-color: #e9e9e9;
    bottom: 0;
    left: 0;
    z-index: 2000;
  }
}
</style>

<script>
export default {
  data() {
    return {
      goods: [],
      pwd_show: false
    };
  },
 
};
</script>
